import React, { useEffect } from 'react';
import Dispatcher from './dispatchers/dispatcher';
import Page from './components/page';
import { Router as DirectorRouter } from 'director/build/director';
import { Router } from './components/router';
import routes from './config/routes';
import { createTheme as createThemeV5, ThemeProvider as ThemeProviderV5 } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import Config from './config/config';
// import SeleniumDebugable from './components/ribbons/seleniumDebugable';
import colors from './stylesheets/base/_colors.scss';
import { lighten } from '@mui/material';
import { StylesProvider } from '@mui/styles';

const { bluewaveBlue, spruceBlue, spruceOrange, spruceRed, modifierLowPercent } = colors;
const modifierLow = parseFloat(modifierLowPercent) / 100;
// const modifierMedium = parseFloat(modifierMediumPercent) / 100;

const Application = () => {
  const { materialProgridLicense } = Config;
  const router = new DirectorRouter(routes);
  LicenseInfo.setLicenseKey(materialProgridLicense);
  Dispatcher.router = router;

  const themeV5 = createThemeV5({
    typography: {
      fontFamily: ['poppins'],
    },
    palette: {
      primary: { main: bluewaveBlue },
      spruceBlue: { main: spruceBlue },
      warning: { main: spruceRed, contrastText: '#FFF' },
      caution: {
        main: spruceOrange,
        contrastText: '#FFF',
        // Button onHover uses the "dark" modifier, but we want these buttons lighter on hover
        dark: lighten(spruceOrange, modifierLow),
      },
      error: { main: spruceRed },
    },
    overrides: {
      MuiLink: {
        root: {
          color: '#24637D',
        },
      },
      MuiSelect: {
        select: {
          '&:focus': {
            backgroundColor: 'white',
          },
        },
      },
    },
  });

  window.sessionStorage.setItem(
    'fetchTraceId',
    window.sessionStorage.getItem('fetchTraceId') || 'RA-' + Math.floor(Math.random() * 999999999999999).toString(16)
  );

  useEffect(() => {
    window.process = { ...window.process };
    if (window.navigator.userAgent.match(/iPad|iPhone/i)) {
      document
        .querySelector('meta[name=viewport]')
        .setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1');
    }
  });

  return (
    <div className="application">
      <StylesProvider>
        <ThemeProviderV5 theme={themeV5}>
          <Page />
          <Router router={router} />
        </ThemeProviderV5>
      </StylesProvider>
    </div>
  );
};

export default Application;
